import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useHomeSectionNav } from '@/features/public/home/context/HomeSectionNavContext';
import HomeSectionNav from '@/features/public/home/components/HomeSectionNav';
import HomeSectionNavBurgerLinks from '@/features/public/home/components/HomeSectionNavBurgerLinks';
import Header from '@/shared/components/layout/Header';
import { syncAfterModeratorAssignment } from '@/features/user/profile/moderatorAssignmentSync';

/**
 * Home-aware header shell — wires HomeSectionNav into shared Header via slots (no shared→features imports).
 */
export default function HomeAppHeader() {
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const homeNav = useHomeSectionNav();
  const isHomePage = pathname === '/';
  const homeSectionsInBurger =
    isHomePage &&
    (homeNav?.sections?.length ?? 0) > 0 &&
    homeNav?.placement === 'burger';

  const handleModeratorAssignmentChanged = useCallback(
    async (obligationId) => {
      await syncAfterModeratorAssignment(queryClient, obligationId);
    },
    [queryClient],
  );

  return (
    <Header
      homeSectionNavDesktop={<HomeSectionNav />}
      homeSectionBurgerLinks={(onClose) => (
        <HomeSectionNavBurgerLinks onNavigate={onClose} />
      )}
      showHomeSectionBurgerLinks={homeSectionsInBurger}
      onModeratorAssignmentChanged={handleModeratorAssignmentChanged}
    />
  );
}
